const {Backbone} = require('backboneAdapter');
import Template from 'templates/subscriber.detailed.delivery.report.hbs';
import Handlebars from 'handlebars';

export default Backbone.View.extend({
    initialize: function (options) {
        this.template = Handlebars.compile(Template);
        this.load(options);
    },
    load: async function (options) {
        const url = this.getReportUrl(options);
        const deliveryReports = await $.getDefaultJSONQ(url);

        this.model = {
            ucFields:{
                voucher: deliveryReports.find(x=>x.voucherCode),
                survey: deliveryReports.find(x=>x.surveyCode),
                file: deliveryReports.find(x=>x.fileCode),
                link: deliveryReports.find(x=>x.linkCode),
                optout: deliveryReports.find(x=>x.optoutCode)
            },
            deliveryReports,
        };
        this.render();
        this.$el.append(this.template(this.model));
    },
    getReportUrl: function (options) {
        return `/CampaignCloud/Report/${options.campaignId}/detailedReport/${options.subscriptionId}`;
    }
});